import _mixin from '../_mixin'

export default {
  name: 'SVersionInvite',
  cnName: '邀请按钮类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: 'LG4LKO7NPTR3LPWGGPN4AFCOOY',
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/a3103f477a328890d4c53bb082f1b981.png',
      style: {
        width: '1920px',
        height: '1106px'
      }
    },
    btnInvite: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/955436a20d941d0c553bcb849809cd75.png',
      style: {
        width: '165px',
        height: '50px',
        position: 'absolute',
        top: '390px',
        right: '',
        bottom: '',
        left: '503px'
      }
    },
    dailogText: '好友邀请您助力，是否同意',
    shareText: '好兄弟，快来帮我助力！真的很想要！是兄弟就来《生死狙击2》！>> '
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnInvite',
      label: '去邀请',
      formType: 'image'
    },
    {
      target: 'shareText',
      label: '分享文案'
    },
    {
      target: 'dailogText',
      label: '弹窗文案'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
